import React, { useState ,useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import {
  showSuccess,
  showError,
} from "../../General/Toast";
const Branch = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  const [exportQty, setExportQty] = useState({});
  const [showInventoryModal, setShowInventoryModal] = useState(false);
const [inventory, setInventory] = useState([]);
const [selectedBranch, setSelectedBranch] = useState(null);
  const [branches, setBranches] = useState([]);
  const [firms, setFirms] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [myDetails, setMyDetails] = useState({});

  const [branchData, setBranchData] = useState({
    business_name: "",
    gstin: "",
    mobile: "",
    address: "",
    state: "",
    pincode: "",
    pass: "",
  });

  useEffect(() => {
  fetchMyDetails();
}, []);



const handleBranchLogin = async () => {
  try {
    setShowLoginModal(false);

const res = await axios.put(
  "https://api.dectwinbilling.com/user-login",
  {
    mobile: selectedBranch.mobile,
    pass: selectedBranch.pass,
    role: "Owner",
  }
);

localStorage.clear();

localStorage.setItem(
  "user_data",
  JSON.stringify(res.data)
);

localStorage.setItem("client_id", res.data.id);
localStorage.setItem("role", "admin");

navigate("/home");
window.location.reload();
  } catch (err) {
  console.log("Error:", err);
  console.log("Response:", err.response);
  console.log("Data:", err.response?.data);

  showError(
    err.response?.data?.message || err.message
  );
}
};
const handleSendNow = async () => {
  try {
const client_id = localStorage.getItem("client_id");
const client_type = localStorage.getItem("role");

    const items = inventory
      .filter((item) => Number(exportQty[item.id]) > 0)
      .map((item) => ({
        ...item,
        stock: Number(exportQty[item.id]),
      }));

    if (items.length === 0) {
      return showError("Please enter quantity.");
    }

    const payload = {
      cust_name: selectedBranch.business_name,
      cust_address: selectedBranch.address,
      cust_number: selectedBranch.mobile,
      gstin: selectedBranch.gst,
      date: new Date().toISOString().split("T")[0],

      payable: 0,
      received: 0,
      due: 0,
      mode: "Stock Transfer",

      sgst: 0,
      cgst: 0,
      igst: 0,

      totalSP: 0,
      totalTax: 0,

      last_discount: 0,
      last_discount_type: "₹",
      onChangeForDiscount: 0,

      client_id,
      client_type,

      items,
    };

    const res = await axios.post(
      `https://api.dectwinbilling.com/send-items/${selectedBranch.mobile}`,
      payload
    );

    showSuccess(res.data.message);

    setShowInventoryModal(false);
    setExportQty({});
  } catch (err) {
    console.log(err);
    showError(err.response?.data?.message || "Something went wrong");
  }
};
const handleSendItems = async (branch) => {
  try {
    console.log("Branch:", branch);
    console.log("Client ID:", branch.client_id);

    setSelectedBranch(branch);

    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-inventory/${branch.client_id}`
    );

    // console.log("Inventory:", res.data);

    setInventory(res.data);
    setShowInventoryModal(true);
  } catch (err) {
    console.log(err);
    showError("No inventory found");
  }
};


const fetchMyDetails = async () => {
  try {
    const clientId = localStorage.getItem("client_id");

    const response = await axios.get(
      `https://api.dectwinbilling.com/my-details/${clientId}`
    );


    const firms = JSON.parse(response.data['firm']);


setBranches(firms.filter(firm => firm.id != 0));
    setMyDetails(response.data);
    getAllBranchDetails(firms.filter(firm => firm.id != 0));
  } catch (error) {
    console.log(error);
  }
};
  const handleChange = (e) => {
    setBranchData({
      ...branchData,
      [e.target.name]: e.target.value,
    });
  };


  const handleSaveBranch = async () => {
    try {
      if (
        !branchData.business_name ||
        !branchData.mobile ||
        !branchData.pass
      ) {
        showError("Please fill all required fields");
        return;
      }


      const clientId = localStorage.getItem("client_id");


      const response = await axios.post(
        "https://api.dectwinbilling.com/create-account",
        {
          business_name: branchData.business_name,
          gstin: branchData.gstin,
          mobile: branchData.mobile,
          address: branchData.address,
          state: branchData.state,
          pincode: branchData.pincode,
          pass: branchData.pass,
          source: "branch",
        }
      );

      // console.log("Create Account Response:", response.data);
const branchId = response.data.id;


await axios.put(
  `https://api.dectwinbilling.com/update-account/${branchId}`,
  {
    gst: branchData.gstin,
    category: "",
    type: "branch",
    address: branchData.address,
    state: branchData.state,
    pin: branchData.pincode,
  }
);


 await axios.put(
  `https://api.dectwinbilling.com/update-my-firms/${clientId}`,
  {
    name: branchData.business_name,
  }
);


showSuccess("Branch created successfully");

await fetchMyDetails();


      setBranchData({
        business_name: "",
        gstin: "",
        mobile: "",
        address: "",
        state: "",
        pincode: "",
        pass: "",
      });

      setShowModal(false);
    } catch (error) {
      console.log(error);

      showError(
        error.response?.data?.message ||
          "Something went wrong"
      );
    }
  };


const getAllBranchDetails = async (branches) => {
  try {
    const details = await Promise.all(
      branches.map(async (branch) => {
        const response = await axios.get(
          `https://api.dectwinbilling.com/branch-details/${branch.name}`
        );

        return response.data;
      })
    );

    setBranches(details);
  } catch (error) {
    console.error("Error fetching branch details:", error);
  }
};

  return (
    <div className="container-fluid px-3 px-md-4 mt-4">

      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h2 className="mb-0">Business Branches</h2>

        <button
          className="btn btn-secondary"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>

{/*
      <button
        className="btn btn-primary mb-3"
        onClick={() => setShowModal(true)}
      >
        + Add New Branch
      </button> */}
      <button
  className="btn mb-3 text-white fw-bold px-4 py-2 rounded-pill shadow"
  style={{
    background: "var(--primary-color)",
    border: "none",
  }}
  onClick={() => setShowModal(true)}
>
  + Add New Branch
</button>

<div className="card shadow-sm mb-4 border-0">
  {/* <div className="card-header bg-primary text-white">
    <h5 className="mb-0">My Business Details</h5>
  </div> */}
  <div
  className="card-header text-white py-3"
  style={{
    backgroundColor: "var(--primary-color)",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
  }}
>
  <h5 className="mb-0 fw-bold">
    My Business Details
  </h5>
</div>

  <div className="card-body">
    <div className="row align-items-center">


      <div className="col-md-3 text-center mb-3 mb-md-0">
        {myDetails.image ? (
          <img
            src={`https://api.dectwinbilling.com/dUploads/${myDetails.image}`}
            alt="Logo"
            className="img-fluid rounded-circle border shadow"
            style={{
              width: "140px",
              height: "140px",
              objectFit: "cover"
            }}
          />
        ) : (
          // <div
          //   className="border rounded-circle d-flex justify-content-center align-items-center mx-auto"
          //   style={{
          //     width: "140px",
          //     height: "140px",
          //     background: "#f8f9fa"
          //   }}
          // >
          //   No Logo
          // </div>

          <div
  className="border rounded-circle overflow-hidden mx-auto"
  style={{
    width: "140px",
    height: "140px",
  }}
>
<img
  src="https://cdn-icons-png.flaticon.com/512/1077/1077114.png"
  alt="Business"
  className="img-fluid rounded-circle border shadow"
  style={{
    width: "140px",
    height: "140px",
    objectFit: "cover",
  }}
/>
</div>
        )}
      </div>

      
      <div className="col-md-9">
        <div className="row">

          <div className="col-md-6 mb-3">
            <strong>Business Name</strong>
            <div>{myDetails.business_name}</div>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Mobile Number</strong>
            <div>{myDetails.mobile}</div>
          </div>

          <div className="col-md-6 mb-3">
            <strong>GST Number</strong>
            <div>{myDetails.gst}</div>
          </div>

          <div className="col-md-6 mb-3">
            <strong>State</strong>
            <div>{myDetails.state}</div>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Address</strong>
            <div>{myDetails.address}</div>
          </div>

          <div className="col-md-6 mb-3">
            <strong>Added On</strong>
            <div>{myDetails.register}</div>
          </div>

        </div>
           <div className="d-flex justify-content-end gap-2 mb-3">

  <button
    className="btn rounded-pill px-4 py-2 fs-5 fw-semibold"
    style={{
      background: "var(--primary-color)",
      color: "#fff",
      border: "none",
    }}
  >
    Primary
  </button>
  </div>
      </div>
      

    </div>
  </div>
</div>

{branches.map((branch, index) => (
  <div className="card shadow-sm mb-4 border-0" key={index}>
    <div
      className="card-header text-white fw-bold"
      style={{ background: "var(--primary-color)" }}
    >
      Branch Details
    </div>

    <div className="card-body">
      <div className="row align-items-center">

        {/* Logo */}
        <div className="col-md-3 text-center mb-3 mb-md-0">
          {branch.image ? (
            <img
              src={`https://api.dectwinbilling.com/dUploads/${branch.image}`}
              alt="Logo"
              className="img-fluid rounded-circle border shadow"
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
              }}
            />
          ) : (
            // <div
            //   className="border rounded-circle d-flex justify-content-center align-items-center mx-auto"
            //   style={{
            //     width: "120px",
            //     height: "120px",
            //     background: "#f8f9fa",
            //   }}
            // >
            //   No Logo
            // </div>
            <div
  className="border rounded-circle overflow-hidden mx-auto"
  style={{
    width: "120px",
    height: "120px",
  }}
>
  <img
    src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
    alt="Default User"
    className="w-100 h-100"
    style={{ objectFit: "cover" }}
  />
</div>
          )}
        </div>

        {/* Details */}
        <div className="col-md-9">
 
          <div className="row">

            <div className="col-md-6 mb-3">
              <strong>Business Name</strong>
              <div>{branch.business_name}</div>
            </div>

            <div className="col-md-6 mb-3">
              <strong>Mobile Number</strong>
              <div>{branch.mobile}</div>
            </div>

            <div className="col-md-6 mb-3">
              <strong>GST Number</strong>
              <div>{branch.gst || "NA"}</div>
            </div>

            <div className="col-md-6 mb-3">
              <strong>State</strong>
              <div>{branch.state || "NA"}</div>
            </div>

            <div className="col-md-6 mb-3">
              <strong>Address</strong>
              <div>{branch.address || "NA"}</div>
            </div>

            <div className="col-md-6 mb-3">
              <strong>Email</strong>
              <div>{branch.email || "Not Provided"}</div>
            </div>

            <div className="col-md-6 mb-3">
              <strong>Added On</strong>
              <div>{branch.register}</div>
            </div>

          </div>
   <div className="d-flex justify-content-end gap-2 mb-3">

<button
  className="btn rounded-pill px-4 py-2 fs-5 fw-semibold"
  style={{
    background: "#e9ecef",
    color: "#000",
    border: "none",
  }}
  onClick={() => {
    setSelectedBranch(branch);
    setShowLoginModal(true);
  }}
>
  Log In
</button>

  <button
    className="btn rounded-pill px-4 py-2 fs-5 fw-semibold text-white"
    style={{
      background: "var(--primary-color)",
      border: "none",
    }}
      onClick={() => handleSendItems(branch)}
  >
    Send Items
  </button>

</div>
        </div>

      </div>
    </div>
  </div>
))}
{showInventoryModal && (
  <div
    className="modal fade show d-block"
    style={{ backgroundColor: "rgba(0,0,0,.5)" }}
  >
    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content rounded-4 border-0 shadow">

        {/* Header */}
        <div
          className="modal-header text-white"
          style={{ background: "var(--primary-color)" }}
        >
          <div>
            <h4 className="mb-0 fw-bold">
              Send Items
            </h4>
            <small>
              {selectedBranch?.business_name} ({selectedBranch?.mobile})
            </small>
          </div>

          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={() => setShowInventoryModal(false)}
          />
        </div>

        {/* Search */}
<div className="position-relative mb-3">
  <FaSearch
    className="position-absolute"
    style={{
      top: "50%",
      left: "15px",
      transform: "translateY(-50%)",
      color: "#6c757d",
      fontSize: "18px",
    }}
  />

  <input
    type="text"
    className="form-control form-control-lg ps-5"
    placeholder="Search by name or barcode"
  />
</div>

        {/* Table */}
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead
              className="text-white"
              style={{ background: "var(--primary-color)" }}
            >
              <tr>
                <th>Name</th>
                <th>Barcode</th>
                <th>Stock</th>
                <th style={{ minWidth: "180px" }}>
                  Export Qty
                </th>
              </tr>
            </thead>

            <tbody>
              {inventory.length > 0 ? (
                inventory.map((item) => (
                  <tr key={item.id}>
                    <td className="fw-semibold">
                      {item.name}
                    </td>

                    <td>{item.barcode}</td>

                    <td>
                      <span className="badge bg-success fs-6">
                        {item.stock}
                      </span>
                    </td>

                    <td>
                    <input
  type="number"
  className="form-control"
  placeholder="Qty"
  min="0"
  value={exportQty[item.id] || ""}
  onChange={(e) =>
    setExportQty({
      ...exportQty,
      [item.id]: e.target.value,
    })
  }
/>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="text-center py-5"
                  >
                    No Inventory Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="modal-footer">

          <button
            className="btn btn-outline-secondary rounded-pill px-4"
            onClick={() => setShowInventoryModal(false)}
          >
            Cancel
          </button>

        <button
  className="btn text-white rounded-pill px-4"
  style={{ background: "var(--primary-color)" }}
  onClick={handleSendNow}
>
  Send Now
</button>

        </div>

      </div>
    </div>
  </div>
)}
{showLoginModal && (
  <div
    className="modal fade show d-block"
    style={{ background: "rgba(0,0,0,.5)" }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content rounded-4">

        <div className="modal-body text-center py-4">
          <h4>You will be redirected to this business</h4>
          <p className="text-muted mb-4">
            (All saved bills will be lost)
          </p>

          <div className="d-flex justify-content-center gap-3">
            <button
              className="btn btn-light"
              onClick={() => setShowLoginModal(false)}
            >
              Cancel
            </button>

            <button
              className="btn text-white"
              style={{ background: "var(--primary-color)" }}
               onClick={handleBranchLogin}
            >
              Go Anyway
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
)}
 {showModal && (
      <div
  className="modal fade show"
  style={{
    display: "block",
    backgroundColor: "rgba(0,0,0,0.5)",
  }}
>
<div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
           <div
  className="modal-content border-0 shadow-lg rounded-4"
>

<div
  className="modal-header border-0"
  style={{
    background: "var(--primary-color)",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
  }}
>
  <h4
    className="modal-title fw-bold mb-0"
    style={{ color: "#fff" }}
  >
    Add New Branch
  </h4>

  <button
    type="button"
    className="btn-close btn-close-white"
    onClick={() => setShowModal(false)}
  />
</div>
              <div className="modal-body">
                <div className="row">

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">
                      Branch Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="business_name"
                      placeholder="Enter branch name"
                      value={branchData.business_name}
                      onChange={handleChange}
                    />
                  </div>

              
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">
                      GSTIN (Optional)
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="gstin"
                      placeholder="Enter GSTIN"
                      value={branchData.gstin}
                      onChange={handleChange}
                    />
                  </div>

            
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">
                      Mobile Number *
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      name="mobile"
                      placeholder="Enter mobile number"
                      value={branchData.mobile}
                      onChange={handleChange}
                    />
                  </div>

            
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">
                      State
                    </label>
                    <select
                      className="form-select"
                      name="state"
                      value={branchData.state}
                      onChange={handleChange}
                    >
                       <option value="">Select State</option>

  <option value="Andhra Pradesh">Andhra Pradesh</option>
  <option value="Arunachal Pradesh">Arunachal Pradesh</option>
  <option value="Assam">Assam</option>
  <option value="Bihar">Bihar</option>
  <option value="Chhattisgarh">Chhattisgarh</option>
  <option value="Delhi">Delhi</option>
  <option value="Goa">Goa</option>
  <option value="Gujarat">Gujarat</option>
  <option value="Haryana">Haryana</option>
  <option value="Himachal Pradesh">Himachal Pradesh</option>
  <option value="Jharkhand">Jharkhand</option>
  <option value="Karnataka">Karnataka</option>
  <option value="Kerala">Kerala</option>
  <option value="Madhya Pradesh">Madhya Pradesh</option>
  <option value="Maharashtra">Maharashtra</option>
  <option value="Manipur">Manipur</option>
  <option value="Meghalaya">Meghalaya</option>
  <option value="Mizoram">Mizoram</option>
  <option value="Nagaland">Nagaland</option>
  <option value="Odisha">Odisha</option>
  <option value="Punjab">Punjab</option>
  <option value="Rajasthan">Rajasthan</option>
  <option value="Sikkim">Sikkim</option>
  <option value="Tamil Nadu">Tamil Nadu</option>
  <option value="Telangana">Telangana</option>
  <option value="Tripura">Tripura</option>
  <option value="Uttar Pradesh">Uttar Pradesh</option>
  <option value="Uttarakhand">Uttarakhand</option>
  <option value="West Bengal">West Bengal</option>
                    </select>
                  </div>

                
                  <div className="col-12 mb-3">
                    <label className="form-label">
                      Address
                    </label>
                    <textarea
                      className="form-control"
                      rows="3"
                      name="address"
                      placeholder="Enter address"
                      value={branchData.address}
                      onChange={handleChange}
                    />
                  </div>

                
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">
                      Pincode
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="pincode"
                      placeholder="Enter pincode"
                      value={branchData.pincode}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Password */}
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">
                      Create Password *
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      name="pass"
                      placeholder="Create password"
                      value={branchData.pass}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

             
  <div className="modal-footer border-0 pt-0">

  <button
    className="btn btn-outline-secondary rounded-pill px-4"
    onClick={() => setShowModal(false)}
  >
    Cancel
  </button>

  <button
    className="btn rounded-pill px-4 text-white"
    style={{
      background: "var(--primary-color)",
      border: "none",
    }}
    onClick={handleSaveBranch}
  >
    Save Branch
  </button>

</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Branch;